export interface ProfileFooterActionsProps {
  onClearDraft: () => void;
  onGoBack: () => void;
  /** Save and Exit exists only when EDITING an existing employee. Omit it (Add Employee) and the button is not rendered. */
  onSaveAndExit?: (() => void) | undefined;
  onSaveAndContinue: () => void;
}

// Matches the approved design's footer action bar (Clear Draft / Go Back / Save and Exit / Save and
// Continue). Deliberately PURE NAVIGATION for this design-review pass — it never calls a save/persistence
// API and never shows a success message, so it can't misrepresent an unsupported field as saved (per
// EPN-38's "Save actions must not falsely claim those values were persisted" rule). The one field group
// that IS genuinely persisted today (Personal Information's name/email) is still only editable from the
// People list's own Edit action, unchanged from the already-shipped behavior — wiring a real per-step save
// into this footer is a follow-up once the rest of Employee Setup's fields are resolved, not part of this
// visual pass.
export function ProfileFooterActions({ onClearDraft, onGoBack, onSaveAndExit, onSaveAndContinue }: ProfileFooterActionsProps) {
  return (
    <div className="profile-footer-actions">
      <button type="button" className="profile-clear-btn" onClick={onClearDraft}>
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <path d="M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.5h5.8l.6-8.5M7 7v4M9 7v4" fill="currentColor" fillOpacity="0.25" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Clear Draft
      </button>
      <div className="right">
        <button type="button" className="profile-btn-outline" onClick={onGoBack}>Go Back</button>
        {onSaveAndExit && <button type="button" className="profile-btn-success" onClick={onSaveAndExit}>Save and Exit</button>}
        <button type="button" onClick={onSaveAndContinue}>Save and Continue</button>
      </div>
    </div>
  );
}
